<template>
  <div class="q-pa-md scroll">
    <q-pull-to-refresh scroll-target=".scroll-div" @refresh="refresh">
      <div>
        <div class="post-wall scroll-div PcViews" @scroll="scrollEvent">
          <AddPostBtn v-if="this.$route.name !== 'FriendPost' && !getIsSetSessionWrong && !isLogin"></AddPostBtn>

          <PostWallCard v-for="item in getPostWallData" :key="item.Id" :postData="item"></PostWallCard>

          <!-- 無動態時/例外發生時的 UI -->
          <ExceptionWall></ExceptionWall>
        </div>
      </div>
    </q-pull-to-refresh>
  </div>
</template>

<script>
import AddPostBtn from '@/components/PostWall/AddPostBtn';
import PostWallCard from '@/components/PostWall/PostWallCard/PostWallCard';
import ExceptionWall from '@/components/PostWall/ExceptionWall';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
export default {
  name: 'PostWall',
  components: {
    AddPostBtn,
    PostWallCard,
    ExceptionWall
  },
  data() {
    return {
      // scrollbar 樣式套件 滾動時不讓父元素跟著跑預設是true
      wheelPropagation: false
    };
  },

  mounted() {
    // 從其他 router 過來此頁時，因已有 session 所以判斷有 session 時就請求取得貼文資料
    if (this.getIsSetSession) {
      this.getApiPostWallData();
    }
  },
  watch: {
    // 監聽若 isSetSession 存入狀況變動要觸發取得貼文牆資料
    isSetSession: function() {
      this.getApiPostWallData();
      this.SET_LOGIN_STATUS(false);
    }
  },

  computed: {
    ...mapState(['isLogin', 'token']),
    ...mapGetters('PostWallModule', ['getPostWallData', 'getPostWallLoadStatus']),
    ...mapGetters(['getIsSetSession', 'getToken', 'getIsSetSessionWrong']),
    // 取得session 是否已存入
    isSetSession() {
      return this.getIsSetSession;
    }
  },
  methods: {
    ...mapMutations(['SET_LOGIN_STATUS',]),
    ...mapActions('PostWallModule', ['getApiPostWallData']),
    // 滾輪事件 需搭配 css 'scroll-div'
    scrollEvent(e) {
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 500) {
        if (this.getPostWallLoadStatus) {
          // 載入下一頁貼文牆貼文資料
          this.getApiPostWallData();
        }
      }
    },
    // 前往設定頁面
    goToSetting() {
      this.$router.push({ name: 'Setting', params: { token: this.getToken } });
    },
    // 下拉刷新
    refresh(done) {
      setTimeout(() => {
        if (this.isIOS) {
          window.location.reload();
        } else {
          // 安卓 location.reload() 會無效，因此使用 location.href，時間戳記需寫在 # 前，不然會被當成同一個網址，不會執行重載入
          let nowUrl = location.href.replace(/\?time=(\S*)end/, '');
          // window.location.href = nowUrl.replace('#/', `?time=${(new Date()).getTime()}end#/`);
          location.replace(nowUrl.replace('#/', `?time=${new Date().getTime()}end#/`));
        }
        done();
      }, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
.scroll {
  height: 100%;
}

.post-wall {
  background-color: $LaleBg;
}

.scroll-div {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
  .post-wall-card {
    padding: 18px;
    padding-bottom: 0;
    background-color: #fff;
    margin-bottom: 12px;
    border: 1px solid #cecccc;
    border-radius: 10px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .PcViews {
    width: 55%;
    margin: 0 auto;
    overflow: auto;
    margin-top: 120px;
    background-color: #e5e5e5;
    scrollbar-width: thin;
  }
  .PcViews::-webkit-scrollbar {
    width: 10px;
  }
  .PcViews::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  }

  .PcViews::-webkit-scrollbar-thumb {
    background-color: white;
    border: 1px solid slategrey;
    border-radius: 25px;
  }
  // .PcViews::-webkit-scrollbar {
  //   display: none;
  // }
}
</style>
